export default "__VITE_ASSET__y2dCfdwR__"